// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","inner":"Footer_inner__8Pox2","copy":"Footer_copy__9nCAK","links":"Footer_links__X9iFI"};